import * as React from 'react';
import { PictureOutlined } from '@ant-design/icons';
import { ColorSquare } from '../../../../../../components/Others/ColorSquare/ColorSquare';
export interface IVisualItemProps {
  value: GQL.IAttributeValue;
}

export class VisualItem extends React.PureComponent<IVisualItemProps> {
  public render() {
    if (this.props.value.colorHex) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <ColorSquare hex={this.props.value.colorHex} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h3 style={{ margin: 0 }}> {this.props.value.title}</h3>
          </div>
        </div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <PictureOutlined style={{ fontSize: 40 }} />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}> {this.props.value.title}</h3>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributeDetail/components/Values/components/VisualItem.tsx